import { observable, configure, action, computed } from 'mobx';
import LocalModel from './localModel';

import util from 'preact-util';
import { route } from 'preact-router';
import PubSub, { topics } from '../lib/pubsub';

configure({ enforceActions: 'always' });

class CustomerStore extends LocalModel {
    constructor() {
        super('customer', {
            namePlural: 'customers',
            sort: '-createdDate',
            limit: 100,
            api: {
                search: {
                    url: '/api/customers/',
                    params: {
                        limit: 15,
                        sort: '-createdDate',
                    },
                },
                load: {
                    url: '/api/customers/',
                    params: {},
                },
                save: {
                    url: '/api/customers/',
                    params: {},
                },
                delete: {
                    url: '/api/customers/',
                    params: {},
                },
            },
        });
    }

    @observable newCustomer = {};

    @observable customer = {};

    @observable customerPublic = {};

    @observable customers = [];

    @observable members = [];

    async dyreIdRegisterClinicInfoV1(clinic) {
        const response = await util.fetchApi(`/api/dyreid/registerclinicinfov1/${clinic}`, { method: 'GET' }, {
        });
        switch (response?.status) {
            case 200:
                // this.updateKeyValue('breeds', response.data);
                return response;
        }
    }

    async dyreIdRegisterVeterinarianInfoV1(veterinary) {
        const response = await util.fetchApi(`/api/dyreid/registerveterinarianinfov1/${veterinary}`, { method: 'GET' }, {
        });
        switch (response?.status) {
            case 200:
                // this.updateKeyValue('breeds', response.data);
                return response;
        }
    }

    // type: Clinic, Vet
    async dyreIdGetclinicvettermsofuseacceptancestatusv1(clinicId, type = 'Clinic') {
        const response = await util.fetchApi(`/api/dyreid/getclinicvettermsofuseacceptancestatusv1/`, { method: 'GET' }, {
            clinicId,
            type,
        });
        switch (response?.status) {
            case 200:
                // this.updateKeyValue('breeds', response.data);
                return response;
        }
    }

    // type: Clinic, Vet
    async dyreIdClinicVetTermsOfUseAcceptanceV1(clinicId, type = 'Clinic') {
        const response = await util.fetchApi(`/api/dyreid/clinicvettermsofuseacceptancev1/`, { method: 'GET' }, {
            clinicId,
            type,
        });
        switch (response?.status) {
            case 200:
                // this.updateKeyValue('breeds', response.data);
                return response;
        }
    }

    async dyreIdGettermsandconditionslink(language) {
        const response = await util.fetchApi(`/api/dyreid/gettermsandconditionslink/`, { method: 'GET' }, {
            language,
        });
        switch (response?.status) {
            case 200:
                // this.updateKeyValue('breeds', response.data);
                return response;
        }
    }

    async loadPublic(id) {
        const response = await util.fetchApi(`/api/customers/public/${id}`, { method: 'GET' }, {});
        if (response?.status === 200) {
            this.updateKeyValue('customerPublic', response.data);
        }
    }

}

const store = new CustomerStore();
export default store;
